module.exports = __webpack_public_path__ + "footer-02.svg?0bcfa575297b5646be646c79df0d54dc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footer-02.svg
// module id = 73
// module chunks = 0